import axios from 'axios';
import apiPaths from '../api-paths.js';

export default {
    index(query = '') {
        return axios.get(`${apiPaths.CRM}/grand-parent${query}`);
    },
};
